<div class="page-content">
<div
  class="sidenav-container"
>
  <div class="sidenav-content">
    <img
      class="logo"
      src="/assets/img/medtronic-academy.svg"
      alt="Medtronic Academy"
      width="248"
      height="17"
    />
    <div class="content">
    </div>
    <div class="footer">
    </div>
  </div>
</div>
  <div [innerHTML]="maintenanceMessage" class="content maintenance-message"></div>
</div>
